import React from 'react';
import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import {i18n} from '../../Utility/Format';
import { NavLink, useLocation } from 'react-router-dom';
import classnames from 'classnames';
  
/**
 * This is a common header for the stage area. It's used by the top-level views that are rendered in the stage.
 * It provides a navigation bar for changing between those views and their according routes.
 */
const StageMenu = (props) => {
    const optionsWhitelist = ['/', '/settlement', '/spot', '/forward'];
    const location = useLocation();

    return (
        <header className="stage-menu">
            <div className="stage-search">{props.search}</div>
            <div className="stage-menu__navigation" role="menubar"> 
                <StageMenuButton className="u-canHide" activeClassName="active" to="/" end>{i18n('dbm.stage.nav.home', 'Home')}</StageMenuButton>
                <StageMenuButton activeClassName="active" to="/settlement">{i18n('dbm.stage.nav.settlement', 'Abrechnung')}</StageMenuButton>
                <StageMenuButton activeClassName="active" to="/spot">{i18n('dbm.stage.nav.spot', 'Spot')}</StageMenuButton>
                <StageMenuButton activeClassName="active" to="/forward">{i18n('dbm.stage.nav.forward', 'Forward')}</StageMenuButton>
            </div>
            {includes(optionsWhitelist, location.pathname) ? props.optionsToggle : null}
        </header>
    );
};

StageMenu.propTypes = {
    //this should be a StageOptionsToggle
    search: PropTypes.node,
    optionsToggle: PropTypes.node
};

const StageMenuButton = (props) => {
    const classNames = classnames('stage-menu__button', props.className);
    return ( 
        <NavLink className={({isActive}) => classNames + (isActive ? ' stage-menu__button--active' : '')} to={props.to} end={props.end}>
            {props.children}
        </NavLink>
    );
};

StageMenuButton.propTypes = {
    to: PropTypes.string.isRequired,
    end: PropTypes.bool
};

export default StageMenu;